import { render, staticRenderFns } from "./ColleaguesFilterPopup.vue?vue&type=template&id=60300bf8&scoped=true&"
import script from "./ColleaguesFilterPopup.vue?vue&type=script&lang=js&"
export * from "./ColleaguesFilterPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60300bf8",
  null
  
)

export default component.exports